<template>
  <div class="relative">
    <select
      v-on:change="setLanguage($event)"
      v-model="$i18n.locale"
      class="block w-auto pr-auto text-white border-transparent focus:outline-none sm:text-sm"
    >
      <option
        v-for="(lang, i) in langs"
        :key="`Lang${i}`"
        :value="lang.toLowerCase()"
        class="bg-gray-500"
      >
        {{ lang }}
      </option>
    </select>
    <div
      class="pointer-events-none absolute inset-y-0 right-9 flex items-center"
    >
      <span v-if="$i18n.locale === 'en'">🇬🇧</span>
      <span v-if="$i18n.locale === 'fr'">🇫🇷</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LanguageSelector",
  data() {
    return {
      langs: ["EN", "FR"],
    };
  },
  methods: {
    setLanguage(event) {
      this.$store.dispatch("language", event.target.value);
      localStorage.setItem("language", event.target.value);
    },
  },
};
</script>

<style></style>
